import { List, Modal, Space, Typography, Flex } from "antd"

import { useState } from "react"
import VSpace from "../common/VSpace"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCheckCircle } from "@fortawesome/pro-solid-svg-icons"
import { green } from "@ant-design/colors"

const { Text } = Typography

type WelcomeToNewRoutingModalProps = {
  onClose: () => void
}

const WelcomeToNewRoutingModal = ({ onClose }: WelcomeToNewRoutingModalProps) => {
  const viewed = window.localStorage.getItem('welcome-to-new-routing-modal') === 'true'
  const [modalVisible, setModalVisible] = useState<boolean>(!viewed)

  return <Modal
    title={'Welcome to the New Routing Experience'}
    open={modalVisible}
    onCancel={() => {
      setModalVisible(false)
      window.localStorage.setItem('welcome-to-new-routing-modal', 'true')
      onClose()
    }}
    cancelButtonProps={{ hidden: true }}
    onOk={() => {
      setModalVisible(false)
      window.localStorage.setItem('welcome-to-new-routing-modal', 'true')
      onClose()
    }}
    okText={"Let's Go!"}
    width={1000}
  >
    <Space style={{ marginTop: 16, marginBottom: 16 }}>
      <VSpace>
        <Text strong style={{ fontSize: '2rem' }}>Plan Smarter. Route Faster.</Text>
        <strong>We've rebuilt routing from the ground up - with better control, cleaner workflows, and a more intuitive design.</strong>
        <Text >Get familiar with what's new before jumping in:</Text>
        <List
          split={false}
          grid={{ gutter: 0, column: 1 }}
          dataSource={[
            'Quickly build your routes from an interactive map',
            'Optimize for the most optimal drive-time',
            'Activate your routes to add them to your calendar',
            'Get fine-grain control of your routes'
          ]}
          renderItem={(item) => (
            <List.Item>
              <Space>
                <FontAwesomeIcon icon={faCheckCircle} color={green.primary} />
                <Text strong>{item}</Text>
              </Space>
            </List.Item>
          )}
        />
      </VSpace>
      <Flex justify='center'>
        
        <iframe
          src={"https://www.loom.com/embed/dca790ff8c1649fc9dca53ec8f5461ad?sid=b80283d5-074e-4418-bcb2-71ac62f5df89"}
          style={{
            width: '500px',
            height: '282px',
            border: 'none',
            borderRadius: 12,
          }}
          allow="autoplay; fullscreen"
          allowFullScreen
        ></iframe>
      </Flex>
    </Space>
  </Modal>
}

export default WelcomeToNewRoutingModal